// Infrastructure
import fixtures from './fixtures.json';

// Domain
import { CountryRepository } from '../../../domain/repository';
import Injectable from '@/modules/shared/domain/di/injectable';

@Injectable()
export default class CountryDummyRepository implements CountryRepository {
  // eslint-disable-next-line class-methods-use-this
  findAll() {
    return Promise.resolve(fixtures);
  }
}
